
export function makeBlogPostURL( title ) {
  return "/blog/" + title.split(" ").join("-").toLowerCase();
};


export function makeProjectURL( title ) {
  return "/projects#" + makeProjectID(title);
};


export function makeProjectID( title ) {
  return "#" + title.split(" ").join("-").toLowerCase();
};